module.exports = __webpack_public_path__ + "web/img/img44.907e8b39.png";